import { Routes, mapToCanActivate } from '@angular/router';
import {
   AuthGuardService,
   ShareholderListGuardService
} from '@appShared/services';
import * as fromContainers from '@appContainers/index';
import { environment } from '@appEnvironments/environment'

export const APP_ROUTES: Routes = [
   {
      path: '',
      component: fromContainers.ShellComponent,
      canActivate: mapToCanActivate([AuthGuardService]),
      children: [
         {
            path: '',
            component: fromContainers.HomeComponent
         },
         {
            path: 'shareholders',
            component: fromContainers.ShareholderListComponent,
            canActivate: [ShareholderListGuardService]
         },
         // {
         //  path: 'admin',
         //  loadChildren: () =>
         //    import('./admin/admin.module').then(mod => mod.AdminModule)
         // },
         {
            path: '404',
            component: fromContainers.PageNotFoundComponent
         },
         { path: '**', redirectTo: '404', pathMatch: 'full' }
      ]
   }
];
